import { Loader } from "@mantine/core";
import styled from "styled-components";
import type { CSSProperties } from "styled-components";

import white_arrow from "../assets/images/icons/open_new.svg";

interface IButton {
	type?: "button" | "reset" | "submit";
	title: string;
	disabled?: boolean;
	className?: string;
	style?: CSSProperties;
	loading?: boolean;
	onClick?: () => void;
}

const Button = styled.button<{ disabled?: boolean }>`
  background-color: ${({ theme }) => theme.colors.primary.green};
  border: none;
  border-radius: 5px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.primary.white};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  cursor: pointer;
  width: 200px;
  height: 50px;
  align-items: center;
  padding: 0 24px;
  ${(props) =>
		props?.disabled &&
		`
         background-color: ${props.theme.colors.primary.disabled};
         cursor:not-allowed
    `}
`;

const TransparentButton = styled.div<{ disabled?: boolean }>`
  border-radius: 6px;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  cursor: pointer;
  width: 200px;
  height: 40px;
  align-items: center;
  padding: 0 24px;
  background-color: transparent;
  font-size: 14px;
  justify-content: center;
  font-family: 'ProximaNovaBold';
  color: ${({ theme }) => theme.colors.primary.green};
  border: 1px solid ${({ theme }) => theme.colors.primary.green};

  ${(props) =>
		!props?.disabled &&
		`
         &:hover {
          background-color: ${props.theme.colors.primary.green};
          color: ${props.theme.colors.primary.white};
      }
    `}

  ${(props) =>
		props?.disabled &&
		`
         background-color: ${props.theme.colors.secondary.disabled};
         cursor:not-allowed;
         color: ${props.theme.colors.primary.white}
    `}
`;

const Button2 = styled(Button)`
  justify-content: center;
  font-size: 14px;
  font-family: 'ProximaNovaBold';
`;

const ButtonText = styled.span``;

export const PrimaryButton = ({
	title,
	disabled,
	loading,
	onClick,
	style,
	className,
}: IButton): JSX.Element => (
	<Button
		type="submit"
		style={style}
		className={className}
		disabled={disabled}
		onClick={() => {
			onClick?.();
		}}
	>
		<ButtonText>{title}</ButtonText>
		{loading ? (
			<Loader size={20} color="#fff" />
		) : (
			<img src={white_arrow} alt="white-arrow" />
		)}
	</Button>
);

export const PrimaryButtonWithoutIcon = ({
	title,
	disabled,
	onClick,
	style,
	className,
	loading,
}: IButton): JSX.Element => (
	<Button2
		style={style}
		className={className}
		disabled={disabled || loading}
		onClick={() => {
			onClick?.();
		}}
	>
		{loading && <Loader size={20} color="#fff" />}
		{!loading && <ButtonText>{title}</ButtonText>}
	</Button2>
);

export const SecondaryButton = ({
	title,
	disabled,
	onClick,
	style,
	className,
}: IButton): JSX.Element => (
	<TransparentButton
		style={style}
		className={className}
		disabled={disabled}
		onClick={(e) => {
			if (disabled) return;
			e?.preventDefault();
			onClick?.();
		}}
	>
		<ButtonText>{title}</ButtonText>
	</TransparentButton>
);

export const WorkflowButton = ({
	title,
	disabled,
	onClick,
	style,
	className,
	loading,
	type,
}: IButton): JSX.Element => (
	<button
		type={type}
		style={style}
		className={className}
		disabled={disabled || loading}
		onClick={() => {
			onClick?.();
		}}
	>
		<div className="flex items-center justify-between w-full rounded-md">
      <span className="text-[14px] font-medium">{title}</span>
      <span className="flex-shrink-0">
        {loading && <Loader size={15} color="#fff" className="ml-3" />}
      </span>
    </div>
	</button>
);
